import { cityStatePageSchema } from '@ecomm/city-state-data'
import {
  useAffirmBannerQuery,
  useConfidenceBarQuery,
  useExpertSectionAssetQuery,
  useGuaranteeAssetQuery,
  useGuaranteeCopyQuery,
  useQuoteWizardQuery
} from '@ecomm/lander'
import { useBenefitsTextQuery } from './useBenefitsTextQuery'

export const useStaticData = (region: string) => {
  const guaranteeAsset = useGuaranteeAssetQuery()
  const benefitsText = useBenefitsTextQuery(region)
  const guaranteeCopy = useGuaranteeCopyQuery()
  const confidenceBarData = useConfidenceBarQuery('5ynnx5XFY9LYRUyZEkN98K')
  const affirmData = useAffirmBannerQuery()
  const expertSectionAssetData = useExpertSectionAssetQuery()
  const quoteWizard = useQuoteWizardQuery('6wRdF53o74w2MhOhBIkzip')

  return {
    affirmData,
    guaranteeAsset,
    confidenceBarData,
    benefitsText,
    guaranteeCopy,
    expertSectionAssetData,
    quoteWizard
  }
}
